export default __webpack_public_path__ + "static/media/basic-pin-small-11.f6c044f3.png";